import { inject, Injectable } from '@angular/core';
import type { UrlTree } from '@angular/router';
import { Router } from '@angular/router';
import type { Observable } from 'rxjs';

import { EnvironmentService } from '@app/core/environment-service';

@Injectable({
  providedIn: 'root',
})
export class OnlyDevGuard {
  readonly #environment = inject(EnvironmentService);
  readonly #router = inject(Router);
  readonly #isDevelop = !this.#environment.getEnvironment().production;

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.#isDevelop) {
      return true;
    } else {
      return this.#router.navigate(['/'], { replaceUrl: true });
    }
  }
}
